module.exports = __webpack_public_path__ + "static/media/0016.d6b898c9.svg";